// Safely parses SQLite's default datetime format ('YYYY-MM-DD HH:MM:SS' — UTC,
// no timezone marker) into a proper Date object.
//
// Why this exists: `new Date('2026-07-23 14:30:00')` is not a standard ISO
// string (no 'T', no 'Z'), so JS engines fall back to interpreting it as
// LOCAL time rather than UTC. The value SQLite actually stored IS UTC — so
// on any machine not running in UTC (e.g. a browser in IST, or a dev server
// in IST), every timestamp parsed this way is silently off by the local
// timezone offset. For India (UTC+5:30) that can shift a date-only display
// across a calendar day boundary near midnight UTC.
//
// Usage: replace `new Date(row.created_at)` with `parseServerDate(row.created_at)`
// wherever a timestamp came from the server's SQLite `datetime('now')` default
// (created_at, updated_at, generated_at, closed_at, last_active, etc.) — NOT
// for timestamps already generated client-side via `.toISOString()`, which are
// already unambiguous.
export function parseServerDate(dt) {
  if (!dt) return new Date(NaN);
  const s = String(dt);
  // Already has a timezone marker (Z or +HH:MM) — safe to parse as-is
  if (/Z$|[+-]\d{2}:\d{2}$/.test(s)) return new Date(s);
  // SQLite's 'YYYY-MM-DD HH:MM:SS' format — force UTC interpretation
  return new Date(s.replace(' ', 'T') + 'Z');
}
